define( 'views/app/drawer/optionRepeaterEmpty',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'tr',
		template: '#tmpl-nf-edit-setting-option-repeater-empty'
	});

	return view;
} );
